<template>
  <div>
    <BlockTitle :subtitle="subtitle" :title="title" />
    <RevCardGrid :cards :layout="gridLayout">
      <template #default="{ card }">
        <ModularCard
          :key="card.id"
          :background="card.background"
          :card-position="cardPosition(card)"
          class="h-full"
          :sections="card.sections"
          :size="size"
          :with-padding="cardsHavePadding"
        />
      </template>
    </RevCardGrid>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import {
  type ModularCard as ModularCardT,
  type ModularCardsCarouselProps,
} from '@backmarket/http-api/src/api-specs-content/models/modular-card'
import BlockTitle from '@backmarket/nuxt-layer-cms/BlockTitle.vue'
import type { ContentBlockProps } from '@backmarket/nuxt-layer-cms/models/content-block'
import { RevCardGrid } from '@ds/components/CardGrid'

import ModularCard from './ModularCard.vue'

const props = withDefaults(
  defineProps<Omit<ModularCardsCarouselProps, 'layout'> & ContentBlockProps>(),
  {
    mobileScreenColumns: 1,
  },
)

const cardPosition = (card: ModularCardT) =>
  props.cards.findIndex((c) => c.id === card.id) + 1
const gridLayout = computed(() => {
  return props.mobileScreenColumns === 2 ? 'fluid' : 'responsive'
})
</script>
